(function () {
  'use strict';

  function initRoadmap(section) {
    if (section.dataset.roadmapReady) return;
    section.dataset.roadmapReady = 'true';

    var video = section.querySelector('[data-roadmap-video]');
    if (!video) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var pauseTimer;

    function play() {
      window.clearTimeout(pauseTimer);
      if (!video.getAttribute('src')) {
        video.src = video.dataset.src;
        video.load();
      }
      video.muted = true;
      var promise = video.play();
      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
      }, { once: true });
      if (video.readyState >= 3 && !video.paused) video.classList.add('is-playing');
      if (promise && promise.catch) promise.catch(function () {});
    }

    function stop() {
      // Fade out first so the pause never shows as a hard stop.
      video.classList.remove('is-playing');
      window.clearTimeout(pauseTimer);
      pauseTimer = window.setTimeout(function () {
        if (!video.classList.contains('is-playing')) video.pause();
      }, 600);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) play();
          else stop();
        });
      }, { threshold: 0.35 }).observe(video.parentElement);
    } else {
      play();
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-section-type="roadmap"]').forEach(initRoadmap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
